import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ligarEscutas, paginaVista } from "./lib/rastreio";


function Rastreio() {
  const { pathname } = useLocation();
  useEffect(() => ligarEscutas(), []);
  useEffect(() => paginaVista(pathname), [pathname]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Rastreio />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
